export const FAQS_ORDER = [
  {
    delivery: 'courier',
    faqs: [
      {
        code: 'N',
        faqs: [
          {
            title: 'Сможет ли другой человек получить мой заказ?',
            url: '/company/faq/zakazy/moj-zakaz/smozhet-li-drugoj-chelovek-poluchit-moj-zakaz/'
          },
          {
            title: 'Дадут ли мне кассовый чек?',
            url: '/company/faq/oplata/dadut-li-mne-kassovyj-chek/'
          },
          {
            title: 'Как получить товарный чек?',
            url: '/company/faq/oplata/kak-poluchit-tovarnyj-chek/'
          },
          {
            title: 'ЭР - если применен ЭР',
            url: '/company/faq/'
          }
        ]
      },
      {
        code: [ 'E', 'L', 'Z', 'H' ],
        faqs: [
          {
            title: 'Сможет ли другой человек получить мой заказ?',
            url: '/company/faq/zakazy/moj-zakaz/smozhet-li-drugoj-chelovek-poluchit-moj-zakaz/'
          },
          {
            title: 'Дадут ли мне кассовый чек?',
            url: '/company/faq/oplata/dadut-li-mne-kassovyj-chek/'
          },
          {
            title: 'Как получить товарный чек?',
            url: '/company/faq/oplata/kak-poluchit-tovarnyj-chek/'
          }
        ]
      },
      {
        code: 'S',
        faqs: [
          {
            title: 'Сможет ли другой человек получить мой заказ?',
            url: '/company/faq/zakazy/moj-zakaz/smozhet-li-drugoj-chelovek-poluchit-moj-zakaz/'
          },
          {
            title: 'Дадут ли мне кассовый чек?',
            url: '/company/faq/oplata/dadut-li-mne-kassovyj-chek/'
          },
          {
            title: 'Как получить товарный чек?',
            url: '/company/faq/oplata/kak-poluchit-tovarnyj-chek/'
          },
          {
            title: 'Почему упаковка товара отличается от той, которую я обычно заказываю?',
            url: '/company/faq/zakazy/tovary/pochemu-upakovka-tovara-otlichaetsya-ot-toj-kotoruyu-ya-obychno-zakazyvayu/',
          },
          {
            title: 'Как отменить заказ?',
            url: '/company/faq/zakazy/moj-zakaz/kak-otmenit-zakaz/'
          }
        ]
      },
      {
        code: 'F',
        faqs: [
          {
            title: 'Почему упаковка товара отличается от той, которую я обычно заказываю?',
            url: '/company/faq/zakazy/tovary/pochemu-upakovka-tovara-otlichaetsya-ot-toj-kotoruyu-ya-obychno-zakazyvayu/',
          },
          {
            title: 'Есть ли в ЕАПТЕКЕ сертификаты, подтверждающие подлинность товаров?',
            url: '/company/faq/zakazy/tovary/est-li-v-eapteke-sertifikaty-podtverzhdayushchie-podlinnost-tovarov/',
          },
          {
            title: 'Можно ли вернуть товар, если он уже оплачен?',
            url: '/company/faq/zakazy/tovary/mozhno-li-vernut-tovar-esli-on-uzhe-oplachen/',
          },
        ]
      }
    ]
  },
  {
    delivery: 'pickup',
    faqs: [
      {
        code: [ 'N', 'E', 'L', 'Z' ],
        faqs: [
          {
            title: 'Сможет ли другой человек получить мой заказ?',
            url: '/company/faq/zakazy/moj-zakaz/smozhet-li-drugoj-chelovek-poluchit-moj-zakaz/'
          },
          {
            title: 'Дадут ли мне кассовый чек?',
            url: '/company/faq/oplata/dadut-li-mne-kassovyj-chek/'
          },
          {
            title: 'Как получить товарный чек?',
            url: '/company/faq/oplata/kak-poluchit-tovarnyj-chek/'
          },
          {
            title: 'Когда можно забрать заказ из аптеки?',
            url: '/company/faq/zakazy/dostavka-i-samovyvoz/kogda-mozhno-zabrat-zakaz-iz-apteki/',
          }
        ]
      },
      {
        code: 'H',
        faqs: [
          {
            title: 'Сможет ли другой человек получить мой заказ?',
            url: '/company/faq/zakazy/moj-zakaz/smozhet-li-drugoj-chelovek-poluchit-moj-zakaz/'
          },
          {
            title: 'Дадут ли мне кассовый чек?',
            url: '/company/faq/oplata/dadut-li-mne-kassovyj-chek/'
          },
          {
            title: 'Как получить товарный чек?',
            url: '/company/faq/oplata/kak-poluchit-tovarnyj-chek/'
          },
          {
            title: 'Почему упаковка товара отличается от той, которую я обычно заказываю?',
            url: '/company/faq/zakazy/tovary/pochemu-upakovka-tovara-otlichaetsya-ot-toj-kotoruyu-ya-obychno-zakazyvayu/',
          },
          {
            title: 'Как отменить заказ?',
            url: '/company/faq/zakazy/moj-zakaz/kak-otmenit-zakaz/'
          },
          {
            title:'Сколько времени будет находиться мой заказ в пункте самовывоза?',
            url: '/company/faq/zakazy/dostavka-i-samovyvoz/skolko-vremeni-budet-nahoditsya-moj-zakaz-v-punkte-samovyvoza/',
          }
        ]
      },
      {
        code: 'F',
        faqs: [
          {
            title: 'Почему упаковка товара отличается от той, которую я обычно заказываю?',
            url: '/company/faq/zakazy/tovary/pochemu-upakovka-tovara-otlichaetsya-ot-toj-kotoruyu-ya-obychno-zakazyvayu/',
          },
          {
            title: 'Есть ли в ЕАПТЕКЕ сертификаты, подтверждающие подлинность товаров?',
            url: '/company/faq/zakazy/tovary/est-li-v-eapteke-sertifikaty-podtverzhdayushchie-podlinnost-tovarov/',
          }
        ]
      }
    ]
  }
];
